/**
 * Format a date string to European DD/MM/YYYY format.
 * Handles: "2026-03-15", "2026-3-15", ISO strings, etc.
 */
export function fmtDate(dateStr) {
  if (!dateStr) return "-";
  try {
    // Handle YYYY-MM-DD format
    if (/^\d{4}-\d{1,2}-\d{1,2}/.test(dateStr)) {
      const [y, m, d] = dateStr.split("T")[0].split("-");
      return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
    }
    // Handle DD/MM/YYYY already
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return dateStr;
    // Fallback: try Date parsing
    const dt = new Date(dateStr);
    if (!isNaN(dt.getTime())) {
      const d = String(dt.getDate()).padStart(2, "0");
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const y = dt.getFullYear();
      return `${d}/${m}/${y}`;
    }
  } catch {}
  return dateStr;
}

/**
 * Convert European DD/MM/YYYY back to YYYY-MM-DD for API storage.
 */
export function toISODate(dateStr) {
  if (!dateStr) return "";
  // Already YYYY-MM-DD
  if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateStr)) return dateStr;
  // DD/MM/YYYY → YYYY-MM-DD
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
    const [d, m, y] = dateStr.split("/");
    return `${y}-${m}-${d}`;
  }
  return dateStr;
}
